module.exports = __webpack_public_path__ + "static/clip-3-d8003679ba720ea85560966f4a5dd0f3.png";